/* gharelu theme helpers: delivery dates, mobile sticky add-to-cart, order tracking */
(function () {
  'use strict';

  /* ---------- Delivery estimate ---------- */
  function addWorkingDays(start, days) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // skip Sundays
    }
    return d;
  }

  function formatDate(d) {
    try {
      return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) {
      return d.toDateString();
    }
  }

  function initDelivery(root) {
    (root || document).querySelectorAll('[data-gh-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 4;
      var max = parseInt(el.getAttribute('data-max'), 10) || 7;
      if (min > max) {
        var t = min;
        min = max;
        max = t;
      }
      var now = new Date();
      var from = formatDate(addWorkingDays(now, min));
      var to = formatDate(addWorkingDays(now, max));
      var strong = document.createElement('strong');
      strong.textContent = min === max ? from : from + ' – ' + to;
      el.textContent = 'Get it by ';
      el.appendChild(strong);
    });
  }

  /* ---------- Sticky add to cart (mobile) ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-gh-sticky-atc]');
    if (!bar || !window.requestAnimationFrame) return;
    var mainButton = document.getElementById(bar.getAttribute('data-button'));
    if (!mainButton) return;
    var stickyButton = bar.querySelector('[data-gh-sticky-button]');
    var stickyPrice = bar.querySelector('[data-gh-sticky-price]');
    var priceBox = document.getElementById(bar.getAttribute('data-price'));

    bar.hidden = false;

    function syncPrice() {
      if (!priceBox || !stickyPrice) return;
      var onSale = priceBox.querySelector('.price--on-sale');
      var source = onSale
        ? priceBox.querySelector('.price-item--sale')
        : priceBox.querySelector('.price__regular .price-item--regular');
      if (source && source.textContent.trim()) stickyPrice.textContent = source.textContent.trim();
    }

    function syncState() {
      var disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      var label = mainButton.querySelector('span');
      if (label && label.textContent.trim()) stickyButton.textContent = label.textContent.trim();
    }

    stickyButton.addEventListener('click', function () {
      if (!mainButton.disabled) mainButton.click();
    });

    // Show the bar once the main button has scrolled above the screen.
    var ticking = false;
    var visible = false;
    function update() {
      ticking = false;
      var scrolledPast = mainButton.getBoundingClientRect().bottom < 0;
      if (scrolledPast === visible) return;
      visible = scrolledPast;
      bar.classList.toggle('is-visible', scrolledPast);
      document.body.classList.toggle('gh-sticky-on', scrolledPast);
      if (scrolledPast) {
        syncPrice();
        syncState();
      }
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();

    if (priceBox && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
      new MutationObserver(syncState).observe(mainButton, { attributes: true, childList: true, subtree: true });
    }
  }

  /* ---------- Track order ---------- */
  function initTrack(root) {
    (root || document).querySelectorAll('[data-gh-track]').forEach(function (form) {
      if (form.getAttribute('data-gh-ready')) return;
      form.setAttribute('data-gh-ready', '1');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = form.querySelector('input[name="awb"]');
        var error = form.parentNode.querySelector('[data-gh-track-error]');
        var value = (input.value || '').trim();
        if (!value) {
          if (error) error.hidden = false;
          input.focus();
          return;
        }
        if (error) error.hidden = true;
        var url = form.getAttribute('data-template').replace('{awb}', encodeURIComponent(value));
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  function init() {
    initDelivery();
    initSticky();
    initTrack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Keep things working while editing in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initDelivery(event.target);
    initTrack(event.target);
  });
})();
